var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaterialSymbolsKeyboardArrowDownRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols:keyboard-arrow-down-rounded"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15 12.0272C15 12.1468 14.9771 12.2629 14.9313 12.3754C14.8855 12.4879 14.8244 12.5812 14.7481 12.6554L10.5343 16.7835C10.3664 16.948 10.1527 17.0303 9.89313 17.0303C9.63359 17.0303 9.41985 16.948 9.25191 16.7835C9.08397 16.619 9 16.4096 9 16.1553C9 15.901 9.08397 15.6916 9.25191 15.5271L12.8244 12.0272L9.25191 8.52727C9.08397 8.36275 9 8.15335 9 7.89908C9 7.64481 9.08397 7.43542 9.25191 7.27089C9.41985 7.10637 9.63359 7.0241 9.89313 7.0241C10.1527 7.0241 10.3664 7.10637 10.5343 7.27089L14.7481 11.399C14.8397 11.4887 14.9047 11.586 14.9432 11.6907C14.9817 11.7954 15.0006 11.9075 15 12.0272Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialSymbolsKeyboardArrowDownRounded);
export default __webpack_public_path__ + "static/media/material-symbols_keyboard-arrow-down-rounded.7e3e2022b98dc7ed5e15a0569c80f769.svg";
export { ForwardRef as ReactComponent };